import { StoreCode } from '../../schema/storeCode';

export const MAX_PRODUCTS_IN_SUBSCRIPTION_QUANTITY = 6;

// This number is inclusive (will be used with <= comparison)
export const MIN_STOCK_BEFORE_OUT_OF_STOCK = 0;

export const maxProductQuantitiesByProductIdForStores: Readonly<
  Record<StoreCode, Readonly<Record<number, number>>>
> = {
  us: {
    6854876102754: 2,
    6893836402786: 2,
    6893835649122: 2,
    6920981839970: 6,
    6920981971042: 6,
    6920982069346: 6
  },
  au: {
    6854876102754: 2,
    6893836402786: 2,
    6893835649122: 2,
    6920981839970: 6,
    6920981971042: 6,
    6920982069346: 6
  },
  nz: {
    6854876102754: 2,
    6893836402786: 2,
    6893835649122: 2,
    6920981839970: 6,
    6920981971042: 6,
    6920982069346: 6
  },
  jp: {},
  eu: {
    8353541849428: 2,
    8983224090964: 2
  },
  uk: {
    6858015342669: 2,
    7050900734029: 2
  },
  qa: {
    7108616290347: 2,
    7128976916523: 2,
    7139022569515: 2,
    7139021914155: 2,
    7159547265067: 6,
    7159546544171: 6,
    7159546970155: 6
  },
  dev: {
    7108616290347: 2,
    7128976916523: 2,
    7139022569515: 2,
    7139021914155: 2,
    7159547265067: 6,
    7159546544171: 6,
    7159546970155: 6
  },
  aud: {
    7108616290347: 2,
    7128976916523: 2,
    7139022569515: 2,
    7139021914155: 2,
    7159547265067: 6,
    7159546544171: 6,
    7159546970155: 6
  },
  nzd: {
    7108616290347: 2,
    7128976916523: 2,
    7139022569515: 2,
    7139021914155: 2,
    7159547265067: 6,
    7159546544171: 6,
    7159546970155: 6
  },
  eud: {
    8368483205399: 2
  },
  ukd: {
    8368483205399: 2
  }
};

export const nextOrderOnlyProductsForStores: Readonly<Record<StoreCode, Readonly<number[]>>> = {
  us: [6893836402786, 6893835649122, 6920981839970, 6920981971042, 6920982069346, 6854876102754],
  au: [6893836402786, 6893835649122, 6920981839970, 6920981971042, 6920982069346, 6854876102754],
  nz: [6893836402786, 6893835649122, 6920981839970, 6920981971042, 6920982069346, 6854876102754],
  eu: [8353541849428, 8983224090964],
  jp: [],
  uk: [6858015342669, 7050900734029],
  qa: [7139022569515, 7139021914155, 7159547265067, 7159546544171, 7159546970155, 7128976916523],
  dev: [7139022569515, 7139021914155, 7159547265067, 7159546544171, 7159546970155, 7128976916523],
  aud: [7139022569515, 7139021914155, 7159547265067, 7159546544171, 7159546970155, 7128976916523],
  nzd: [7139022569515, 7139021914155, 7159547265067, 7159546544171, 7159546970155, 7128976916523],
  eud: [8368483205399],
  ukd: [8368483205399]
};

export const customerHappinessProductsForStores: Readonly<Record<StoreCode, Readonly<number[]>>> = {
  us: [
    40202986258530, 39420596486242, 40421215633506, 39420596224098, 40532403388514, 40532425506914,
    40532433961058, 39420596584546
  ],
  au: [
    40202986258530, 39420596486242, 40421215633506, 39420596224098, 40532403388514, 40532425506914,
    40532433961058, 39420596584546
  ],
  nz: [
    40202986258530, 39420596486242, 40421215633506, 39420596224098, 40532403388514, 40532425506914,
    40532433961058, 39420596584546
  ],
  jp: [],
  eu: [
    39542353330245, 46807543546196, 39542352674885, 39542353985605, 39542354477125, 39542354116677
  ],
  uk: [
    39477158379597, 39477152153677, 39477164343373, 39477161033805, 39477160181837, 39477151694925,
    39477154021453, 39477157822541, 40133982781517
  ],
  qa: [],
  dev: [],
  aud: [],
  nzd: [],
  eud: [],
  ukd: []
};

// These numbers are the "inventory_item_id" of products
export const outOfStockThresholdByInventoryIdForStores: Readonly<
  Record<StoreCode, Readonly<Record<number, number>>>
> = {
  us: {
    42620340502626: 20
  },
  au: {
    42620340502626: 20
  },
  nz: {
    42620340502626: 20
  },
  jp: {},
  eu: {},
  uk: {},
  qa: {
    43021264322603: 20
  },
  dev: {},
  aud: {
    43021264322603: 20
  },
  nzd: {
    43021264322603: 20
  },
  eud: {},
  ukd: {}
};
